import React, { lazy } from "react";
import { BC_HQ } from "app_constants";
import { AuditLogsIcon } from "components/icons/AuditLogsIcon";
import { DateRangeSupport } from "helpers/shared/formatters/dates";

import { type FeatureFlags, LD_FEATURE_FLAGS } from "types/context";
import type { ISectionProps } from "types/navigation";

const isAuditLogFeatureEnabled = (featureFlags: FeatureFlags) => {
  if (!featureFlags[LD_FEATURE_FLAGS.auditLogPOS]) {
    return false;
  }
  return (
    featureFlags[LD_FEATURE_FLAGS.auditLogChecksCategory] ||
    featureFlags[LD_FEATURE_FLAGS.auditLogServersCategory] ||
    featureFlags[LD_FEATURE_FLAGS.auditLogDevicesCategory] ||
    featureFlags[LD_FEATURE_FLAGS.auditLogPrintersCategory]
  );
};

const AUDIT_LOGS: ISectionProps = {
  feature: "Audit Logs",
  icon: <AuditLogsIcon />,
  path: "/audit-logs",
  level: ["store"],
  dateSupport: DateRangeSupport.NONE,
  requiresFeatureFlagHandler: isAuditLogFeatureEnabled,
  subSections: [
    {
      feature: "Dashboard",
      app: BC_HQ,
      component: lazy(() => import("containers/audit_logs/dashboard")),
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/audit-logs/dashboard",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Checks",
      app: BC_HQ,
      component: lazy(
        () => import("containers/audit_logs/checks/check_selection")
      ),
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/audit-logs/checks",
      dateSupport: DateRangeSupport.NONE,
      requiresFeatureFlag: LD_FEATURE_FLAGS.auditLogChecksCategory,
    },
    {
      feature: "Servers",
      app: BC_HQ,
      component: lazy(
        () => import("containers/audit_logs/servers/server_selection")
      ),
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/audit-logs/servers",
      dateSupport: DateRangeSupport.NONE,
      requiresFeatureFlag: LD_FEATURE_FLAGS.auditLogServersCategory,
    },
    {
      feature: "Devices",
      app: BC_HQ,
      component: lazy(
        () => import("containers/audit_logs/devices/device_selection")
      ),
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/audit-logs/devices",
      dateSupport: DateRangeSupport.NONE,
      requiresFeatureFlag: LD_FEATURE_FLAGS.auditLogDevicesCategory,
    },
    {
      feature: "Printers",
      app: BC_HQ,
      component: lazy(
        () => import("containers/audit_logs/printers/printer_selection")
      ),
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/audit-logs/printers",
      dateSupport: DateRangeSupport.NONE,
      requiresFeatureFlag: LD_FEATURE_FLAGS.auditLogPrintersCategory,
    },
  ],
};

export default AUDIT_LOGS;
